import React, { useState } from "react";
import "../styles/FeaturesAndProcess.css";

function FeaturesAndProcess() {
  const [activeTab, setActiveTab] = useState("buy");

  const buySteps = [
    {
      number: 1,
      title: "Inquiry Received",
      description: "Submit an inquiry via WhatsApp, Form, or Login to get started. Our team will promptly review your request.",
      position: "left"
    },
    {
      number: 2,
      title: "Deal Confirmation",
      description: "Once your inquiry is processed, our experts connect with you to discuss details and lock in the deal.",
      position: "right"
    },
    {
      number: 3,
      title: "KYC & Documentation",
      description: "Submit the required KYC documents for verification. This ensures a safe and compliant transaction.",
      position: "left"
    },
    {
      number: 4,
      title: "Payment & Settlement",
      description: "Receive detailed transfer instructions and complete your payment securely to move forward.",
      position: "right"
    },
    {
      number: 5,
      title: "Share Transfer & Closure",
      description: "Once the payment is confirmed, shares are transferred to your account, marking the completion of the transaction.",
      position: "left"
    }
  ];

  const sellSteps = [
    {
      number: 1,
      title: "Inquiry Received",
      description: "Submit an inquiry via WhatsApp, Form, or Login to get started. Our team will promptly review your request.",
      position: "left"
    },
    {
      number: 2,
      title: "Deal Confirmation",
      description: "Once your inquiry is processed, our experts connect with you to discuss details and lock in the deal.",
      position: "right"
    },
    {
      number: 3,
      title: "KYC & Documentation",
      description: "Submit the required KYC documents for verification. This ensures a safe and compliant transaction.",
      position: "left"
    },
    {
      number: 4,
      title: "Share Transfer",
      description: "Once the payment is confirmed, shares are transferred to your account, marking the completion of the transaction.",
      position: "right"
    },
    {
      number: 5,
      title: "Payment & Settlement",
      description: "Receive detailed transfer instructions and complete your payment securely to move forward.",
      position: "left"
    }
  ];

  const features = [
    {
      icon: "💸",
      title: "Zero Transaction Fees",
      description: "We believe in fair investing! Enjoy seamless buying and selling of unlisted shares with zero transaction fees—keep more of your returns."
    },
    {
      icon: "📋",
      title: "No Stamp Duty Fees",
      description: "Unlike traditional stock investments, we waive stamp duty charges on unlisted IPO transactions. That's more savings straight into your portfolio."
    },
    {
      icon: "💳",
      title: "Free & Easy Transactions",
      description: "Fund your account with confidence—no payment gateway fees ensure you pay only for your investments, not for transactions."
    },
    {
      icon: "📊",
      title: "100% Transparent Pricing",
      description: "What you see is what you get. We don't believe in hidden fees or unexpected deductions—just transparent, hassle-free investing."
    }
  ];

  const currentSteps = activeTab === "buy" ? buySteps : sellSteps;

  return (
    <div className="features-process-container">
      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title-feature">
          Zero Hidden Charges – 100% Transparent Investing
        </h2>
        <p className="section-subtitle">
          Start your investment journey with complete transparency and zero hidden costs
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <h2 className="section-title-dark">
          Simple & Secure – Your Investment Journey Explained
        </h2>
        <p className="section-subtitle-dark">
          Invest in unlisted shares seamlessly. Here's what happens after you confirm your deal
        </p>

        <div className="process-tabs">
          <button
            className={`tab-btn ${activeTab === "buy" ? "active" : ""}`}
            onClick={() => setActiveTab("buy")}
          >
            Buy Process
          </button>
          {/* <button
            className={`tab-btn ${activeTab === "sell" ? "active" : ""}`}
            onClick={() => setActiveTab("sell")}
          >

            Sell Process
          </button> */}
                  <button
          className={`tab-btn ${activeTab === "sell" ? "active-sell" : ""}`}
          onClick={() => setActiveTab("sell")}
        >
          Sell Process
        </button>

        </div>

        <div className="timeline-container">
          <div className="timeline-line"></div>
          {currentSteps.map((step, index) => (
            <div
              key={index}
              className={`timeline-step ${step.position}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default FeaturesAndProcess;